import ApiService from './api.service.js';
const distributorsUrl = '/core/distributors';

export default {
  getDistributorDate(distributorId) {
    return ApiService.get(`/core/distributors/${distributorId}`);
  },
  updateDistributor(distributorId, data) {
    return ApiService.put(`${distributorsUrl}/${distributorId}`, JSON.stringify(data));
  },
  updateDistributorLogo(distributorId, logo) {
    return ApiService.post(`${distributorsUrl}/${distributorId}/logo`, JSON.stringify(logo));
  },
  purchaseCredits(distributorId, creditsData) {
    return ApiService.post(`${distributorsUrl}/${distributorId}/credits/purchases`, creditsData);
  }
};
